import templateStr from 'text!./job-underwriting-issues.html';
import _ from 'lodash';
import uwutil from 'edge/gateway/util/UWUtil';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            job: '=',
            jobService: '=',
            edit: '=',
            withdraw: '=',
            canWithdraw: '=',
            canContinue: '='
        },
        controller: ['$scope', '$q', 'ModalService', 'InsuranceSuiteMetadata', 'TranslateService', 'UserInfoService',
            ($scope, $q, ModalService, InsuranceSuiteMetadata, TranslateService, UserInfoService) => {
                $scope.noteForUW = {'note': ''};
                $scope.referToUW = false;
                $scope.isAgent = UserInfoService.isAgent();

                const blockingPoints = InsuranceSuiteMetadata.get('pc').types.getTypelist('UWIssueBlockingPoint');

                if (!$scope.canContinue) {
                    $scope.canContinue = true;
                }

                $scope.openReferToUWForm = () => {
                    $scope.referToUW = true;
                    $scope.noteForUW.note = '';
                };

                $scope.closeReferToUWForm = () => {
                    $scope.referToUW = false;
                    $scope.noteForUW.note = '';
                };

                $scope.referQuoteToUnderWriter = () => {
                    $scope.noteForUW.note = ($scope.noteForUW.note === '') ? null : $scope.noteForUW.note;
                    $scope.lockAndSendForReviewPromise = $scope.jobService.referToUnderwriter($scope.job.jobNumber, $scope.noteForUW.note).then(
                        (job) => {
                            $scope.job = job;
                            $scope.$emit('activitiesUpdated');
                        },
                        () => {
                            ModalService.showError('gateway.views.modal.Error', 'gateway.views.job-uwissues.There was an error sending the job for review');
                        }
                    );
                    $scope.closeReferToUWForm();
                };

                $scope.getUWStatus = (issue) => {
                    const status = blockingPoints.getCode(issue.currentBlockingPoint);
                    return (issue.currentBlockingPoint === 'NonBlocking' && issue.hasApprovalOrRejection) ? TranslateService.instant('gateway.views.job-uwissues.Approved') : status.name;
                };

                $scope.showUWIssuesAlert = () => $scope.uwutil.hasUwIssues && !['Bound', 'Withdrawn'].includes($scope.job.statusCode);

                $scope.showMessageBox = () => {
                    return ($scope.job) ? !$scope.job.isEditLocked && $scope.referToUW && $scope.job.statusCode !== 'Withdrawn' && $scope.uwutil.uwIssuesAreBlocking : false;
                };

                $scope.showUWIssuesTriggeredMsg = () => $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && $scope.uwutil.uwIssuesAreBlocking && !$scope.uwutil.uwIssuesHaveBeenInspectedByUW && ['Draft', 'Quoted'].includes($scope.job.statusCode);

                $scope.showReferredToUWMsg = () => $scope.showUWIssuesAlert() && $scope.job.isEditLocked && $scope.uwutil.hasUwIssues && $scope.job.createdByMe;

                $scope.showUWIssuesRejectedMsg = () => $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && $scope.uwutil.uwIssuesHaveBeenInspectedByUW;

                $scope.showUWIssuesApprovedMsg = () => $scope.showUWIssuesAlert() && !$scope.job.isEditLocked && !$scope.uwutil.uwIssuesAreBlocking;

                $scope.getUWIssueStatusByOffering = (uwIssue, offering) => {
                    const currentUWIssue = offering ? _.find(uwIssue.onOfferings, (offer) => {
                        return offer.offering === offering;
                    }) : uwIssue;

                    let displayStatus = TranslateService.instant('gateway.views.job-uwissues.N/A');
                    if (!currentUWIssue) {
                        return displayStatus;
                    }

                    if (currentUWIssue.currentBlockingPoint) {
                        displayStatus = blockingPoints.getCode(currentUWIssue.currentBlockingPoint).name;
                    }

                    return (currentUWIssue.currentBlockingPoint === 'NonBlocking' && currentUWIssue.hasApprovalOrRejection) ? TranslateService.instant('gateway.views.job-uwissues.Approved') : displayStatus;
                };

                $scope.theJobStateForLock = () => {
                    return ['Withdrawn'].includes($scope.job.statusCode);
                };

                $scope.$watch('job', () => {
                    $scope.uwutil = uwutil($scope.job, $scope.isAgent);
                });
            }]
    };
}];
